import { FC } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuthContext } from '@/context/AuthContext.tsx';
import Routes from '@/router/Routes.ts';
import Middleware from '@/router/middleware/index.tsx';
import OnboardingStep, { allOnboardingSteps } from '$/_const/OnboardingStep.ts';

const DnaCreated: FC = () => {
  const { user, isLoading } = useAuthContext();

  const isDnaCreated =
    !!user?.onboarding_step &&
    allOnboardingSteps.indexOf(user?.onboarding_step) > allOnboardingSteps.indexOf(OnboardingStep.DNA_CONFIRMATION);

  return (
    <Middleware isLoading={isLoading}>
      {isDnaCreated ? <Outlet /> : <Navigate to={Routes.ONBOARDING__DNA} />}
    </Middleware>
  );
};

export default DnaCreated;
